import React from "react";

export const PlayCircleFill: React.FC<any> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
  >
    <g>
      <g>
        <path
          d="M2.5,10C2.5,5.8578600000000005,5.8578600000000005,2.5,10,2.5C14.1421,2.5,17.5,5.8578600000000005,17.5,10C17.5,14.1421,14.1421,17.5,10,17.5C5.8578600000000005,17.5,2.5,14.1421,2.5,10ZM8.375,12.8146C8.607050000000001,12.9486,8.89294,12.9486,9.125,12.8146L12.875,10.6495C13.1071,10.51556,13.25,10.26794,13.25,10C13.25,9.73206,13.1071,9.48444,12.875,9.3505L9.125,7.18542C8.89294,7.05144,8.607050000000001,7.05144,8.375,7.18542C8.142949999999999,7.31939,8,7.56699,8,7.83494L8,12.16506C8,12.433,8.142949999999999,12.6806,8.375,12.8146Z"
          fill="currentColor"
          fillOpacity="1"
        />
      </g>
    </g>
  </svg>
);
